import { initializeApp, getApps, getApp } from "firebase/app";
import { initializeAuth, getReactNativePersistence, getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

const firebaseConfig = {
  apiKey: "AIzaSyA6FDgwjrH-m1J1YzOomN4k0xK28AhGn2Q",
  authDomain: "crease-cricket.firebaseapp.com",
  projectId: "crease-cricket",
  storageBucket: "crease-cricket.firebasestorage.app",
  messagingSenderId: "425029836378",
  appId: "1:425029836378:web:2a3c975aa96c5af818c263",
  measurementId: "G-XWTPRE8179",
};

// Prevent re-initialization on hot reload
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

function getAuthInstance() {
  if (Platform.OS === "web") {
    return getAuth(app);
  }
  try {
    return initializeAuth(app, {
      persistence: getReactNativePersistence(AsyncStorage),
    });
  } catch {
    // Already initialized — return existing instance
    return getAuth(app);
  }
}

export const auth = getAuthInstance();
export const db = initializeFirestore(app, {
  localCache: Platform.OS === "web"
    ? memoryLocalCache()
    : persistentLocalCache({}),
});
export const functions = getFunctions(app, "europe-west2");
export default app;
